'use client';
import React from 'react';
import Link from 'next/link';
import { classNames } from '@repo/ui/src/utils/classNames';
import { useCurrencyString } from '@repo/ui/src/hooks/useCurrencyString';
import type { MeaterProductSummary } from '@src/domain/types/MeaterProductSummary';

interface Props {
  item: MeaterProductSummary;
  selected: boolean;
  productUrl?: string;
}

const MeaterProductCard = ({ item, selected, productUrl }: Props) => {
  const getCurrencyString = useCurrencyString();

  const interior = (
    <div className="grid grid-cols-[72px_1fr] gap-4 p-2 items-center">
      <div className="flex items-center justify-center">
        {item.image ? (
          <img
            src={item.image.url}
            alt={item.image.accessibilityLabel ?? ''}
            className="w-full max-h-24 object-contain"
          />
        ) : (
          <div className="w-full h-24" aria-hidden="true" />
        )}
      </div>
      <div>
        <p className="tra-text-web-heading-5">{item.title}</p>
        <span className="font-bold mt-1 block">
          {getCurrencyString(item.price)}
          {item.compareAtPrice && (
            <del className="text-neutral-500 ml-2 font-normal">
              <span className="sr-only">Original price: </span>
              {getCurrencyString(item.compareAtPrice)}
            </del>
          )}
        </span>
      </div>
    </div>
  );

  return (
    <li
      aria-current={selected ? 'true' : 'false'}
      role="group"
      aria-label="product"
      className={classNames(
        'bg-white w-full items-center',
        selected && 'border-2 border-brand-300',
        !selected && 'border border-neutral-200',
      )}
    >
      {!selected && productUrl ? <Link href={productUrl}>{interior}</Link> : interior}
    </li>
  );
};

export default MeaterProductCard;
